import ConfirmationBlock from '../ConfirmationBlock';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';

const CampaignLaunched = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDraft = location?.state?.draft || false;
  return (
    <div className="campaign-launched">
      <ConfirmationBlock
        img={confirmImg}
        title={`Campaign ${isDraft ? 'Drafted' : 'Launched'} Successfully!`}
        btns={<Button onClick={() => navigate('/campaign-manager')}>Go Back</Button>}
      />
    </div>
  );
};

export default CampaignLaunched;
